// extracted by mini-css-extract-plugin
module.exports = {"bf-icon":"bf-icon__43+md","low-icon":"low-icon__2BKWc","medium-icon":"medium-icon__VYP0O","high-icon":"high-icon__lvf+9"};